import { globalConst } from "src/app/shared/helpers/constants";
import { BASE_BACKEND, ENDPOINT } from "src/app/shared/http/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/services/auth.service";
export class ReportService {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
    }
    getInventory(queryParams) {
        const params = this.authService.getUserLogged().type !== globalConst.defaults.user.admin
            ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
            : queryParams || "";
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.inventory}?${params}`)
            .toPromise()
            .then((data) => data || [])
            .catch((error) => error);
    }
    getEta(queryParams) {
        const params = this.authService.getUserLogged().type !== globalConst.defaults.user.admin
            ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
            : queryParams || "";
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.inventory}eta/?${params}`)
            .toPromise()
            .then((data) => data || [])
            .catch((error) => error);
    }
    getEtaIndicators(queryParams) {
        const params = this.authService.getUserLogged().type !== globalConst.defaults.user.admin
            ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
            : queryParams || "";
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.inventory}eta-indicators/?${params}`)
            .toPromise()
            .then((data) => data || [])
            .catch((error) => error);
    }
    getInventoryIndicators(queryParams) {
        const params = this.authService.getUserLogged().type !== globalConst.defaults.user.admin
            ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
            : queryParams || "";
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.inventory}indicators/?${params}`)
            .toPromise()
            .then((data) => data || [])
            .catch((error) => error);
    }
    getAccess(queryParams) {
        const params = this.authService.getUserLogged().type !== globalConst.defaults.user.admin
            ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
            : queryParams || "";
        return this.http
            .get(`${BASE_BACKEND}user/report/access?${params}`)
            .toPromise()
            .then((data) => data || [])
            .catch((error) => error);
    }
}
ReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportService_Factory() { return new ReportService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: ReportService, providedIn: "root" });
